import React, { useRef } from "react";
import { Button, Box, CircularProgress, MenuItem, Select } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel } from "@mui/material";
import companyService from "../../services/companyService";
import { fileToBase64 } from "../../shared/sharedFunctions";
import alertService from "../../services/alertService";

const PolicyUploadModal = (props) => {
	
	const policyFile = useRef(null);
	const name = useRef(null);
	const category = useRef(null);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		
		if (!companyService.selectedCompany.usecure_id) {
			alertService.show("Unable to upload documents for Demo account.")
			return;
		}
		
		fileToBase64(e.target.policyFile.files[0])
		.then((fileBase64) => {
			const policy = {
				policyFile: fileBase64,
				company_id: companyService.selectCompany.id,
				name: name.current.value,
				category: category.current.value
			};
			
			props.onSubmit(policy);
		})
		.catch((err) => {
			console.log(`ERROR: ${err}`);
		});
	};
	
	const handleCancel = () => {
		props.onClose()
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Upload Policy
			</DialogTitle>
			<DialogContent>
				{ props.loading &&
					<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
						<CircularProgress sx={{ margin: "auto", textAlign: "center" }} />
					</Box>
				}
				{ !props.loading &&
					<form id="policyForm" onSubmit={handleSubmitForm} autoComplete="off">
						<FormControl sx={formControlStyle}>
							<Input
								inputRef={policyFile}
								id="policyFile"
								type="file"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
						<FormControl sx={{ ...formControlStyle, marginBottom: "2em" }}>
							<InputLabel htmlFor="name">Document Name</InputLabel>
							<Input
								inputRef={name}
								id="name"
								type="text"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="category" sx={{ backgroundColor: "background.inputLabel" }}>Category</InputLabel>
							<Select inputRef={category} id="category" disableUnderline="true" defaultValue="other">
								<MenuItem value="other" selected>Other</MenuItem>
								<MenuItem value="essential">Essential</MenuItem>
								<MenuItem value="encryption">Encryption</MenuItem>
								<MenuItem value="mobile" selected>Mobile</MenuItem>
								<MenuItem value="server">Server</MenuItem>
								<MenuItem value="compliance">Compliance</MenuItem>
							</Select>
						</FormControl>
					</form>
				}
			</DialogContent>
			{ !props.loading &&
				<DialogActions>
					<Button onClick={handleCancel}>Cancel</Button>
					<Button type="submit" form="policyForm" autoFocus>Submit</Button>
				</DialogActions>
			}
		</Dialog>
	);
};

export default PolicyUploadModal;